<ul *ngIf="tierBenefits" class="unstyled light-type">
  <li *ngFor="let benefit of tierBenefits; let last = last" class="flex" [class.ms-xxsmall-b]="!last">
    <fcom-icon
      class="icon-medium ms-xsmall-r birch-900-text flex--shrink0"
      aria-hidden="true"
      [name]="SvgLibraryIcon.CHECKMARK"
    ></fcom-icon>
    <span>
      {{ benefit }}
    </span>
  </li>
</ul>

<fcom-notification
  class="block mr-small-t"
  [iconName]="SvgLibraryIcon.INFO"
  [theme]="NotificationTheme.INFO"
  [layout]="NotificationLayout.BLOCK"
>
  {{ 'MMB.tierBenefits.notification' | finLocalization }}
</fcom-notification>

<a
  class="block mr-small-t ms-xsmall-l accommodate-icon light-type font-body-1 link underline"
  [attr.href]="baseTranslation + '.linkUrl.url' | finLocalization"
  [attr.aria-label]="'ariaLabels.newTab' | finLocalization"
  target="_blank"
>
  {{ baseTranslation + '.linkText' | finLocalization }}
  <fcom-icon class="icon-medium ms-xxsmall-b" [name]="SvgLibraryIcon.EXTERNAL_TAB"></fcom-icon>
</a>
